import { action } from '@ember/object';
import Component from '@glimmer/component';

import { UserLevel } from 'webapp/enums/enums';

import type { OptionRaw } from 'webapp/components/form/select';
import FormSelectWithPopupAsDropdownComponent from 'webapp/components/form/select-with-popup-as-dropdown';
import UserPopupRoleSelectComponent from 'webapp/components/user/popup-role-select';

interface Args {
	selected: UserLevel;
	isDisabled: boolean;
	onChange: (item: LabelValuePairNumeric) => void;
	theme?: string;
	size?: string;
}

export default class UserRolesSelectDropdownComponent extends Component<Args> {
	popupComponent = UserPopupRoleSelectComponent;
	popupClass = 'popup-role-select';

	get options(): OptionRaw<number>[] {
		return [
			{
				value: UserLevel.ADMIN,
				label: 'Admin',
				description: 'Full and unrestricted access to everything.',
			},
			{
				value: UserLevel.EDITOR,
				label: 'Editor',
				description:
					'View and edit permissions to dashboards they have access to. They can create new dashboards, connect new data sources and have full access to those.',
			},
			{
				value: UserLevel.USER,
				label: 'User',
				description:
					'View only permission to dashboards they have access to. They can create new dashboards, connect new data sources and have full access to those.',
			},
			{
				value: UserLevel.VIEWER,
				label: 'Viewer',
				description: 'Can only view accessible dashboards.',
			},
		];
	}

	@action
	getPopupProps() {
		return {
			options: this.options,
			onChange: this.args.onChange,
		};
	}

	@action
	blank(): void {
		// do nothing
	}
	<template>
		<FormSelectWithPopupAsDropdownComponent
			@selected={{@selected}}
			@options={{this.options}}
			@onChange={{this.blank}}
			@popupComponent={{this.popupComponent}}
			@popupClass={{this.popupClass}}
			@popupOffset={{-9}}
			@placeholder="User role"
			@getPopupProps={{this.getPopupProps}}
			@isDisabled={{@isDisabled}}
			@theme={{@theme}}
			@size={{@size}}
		/>
	</template>
}
